import { create } from 'zustand';
import { actionItemApi, ActionItem } from '@/api/actionItemApi';

interface ActionItemState {
  actionItems: ActionItem[];
  count: number;
  loading: boolean;
  fetchActionItems: () => Promise<void>;
  fetchCount: () => Promise<void>;
}

export const useActionItemStore = create<ActionItemState>((set) => ({
  actionItems: [],
  count: 0,
  loading: false,

  fetchActionItems: async () => {
    set({ loading: true });
    try {
      const items = await actionItemApi.getAll();
      set({ actionItems: items, count: items.length, loading: false });
    } catch (error) {
      console.error('Failed to fetch action items', error);
      set({ loading: false });
    }
  },

  fetchCount: async () => {
    try {
      const count = await actionItemApi.getCount();
      set({ count });
    } catch (error) {
      console.error('Failed to fetch action item count', error);
    }
  },
}));
